import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "components/ui/toast";

export const useGetPlatformCostSummaryQuery = (params = {}, enabled = true) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_PLATFORM_COST_SUMMARY, params],
    queryFn: () => api.get(API_ROUTES.GET_PLATFORM_COST_SUMMARY, { params }),
    enabled,
  });
  return {
    data: data?.data?.data ?? null,
    isPending,
    isError,
    error,
  };
};

export const useSetPlatformMonthlyPriceMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ provider, month, amount }) =>
      api.put(API_ROUTES.SET_PLATFORM_MONTHLY_PRICE, {
        provider,
        month,
        amount,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_ROUTES.GET_PLATFORM_COST_SUMMARY],
      });
    },
    onError: () => showToast("error", "Failed to save monthly price"),
  });
};
